/** Address on a single line, for inserting into a chat message. */
export default function (address, translate = null) {
  return formatAddress(address, translate).join(', ');
}
